import { render, staticRenderFns } from "./MentionForm.vue?vue&type=template&id=155c13db&scoped=true"
import script from "./MentionForm.vue?vue&type=script&lang=js"
export * from "./MentionForm.vue?vue&type=script&lang=js"
import style0 from "./MentionForm.vue?vue&type=style&index=0&id=155c13db&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155c13db",
  null
  
)

export default component.exports